import EmptyPortalCard from "./EmptyPortalCard";

export default EmptyPortalCard;
